import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "../features/api/apiSlice";
import assignmentsReducer from "../features/assignments/assignmentSlice";
import authReducer from "../features/auth/authSlice";
import videosReducer from "../features/videos/videoSlice";

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    // projects: projectReducer,
    auth: authReducer,
    videos: videosReducer,
    assignments: assignmentsReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});
